@if (directDepositForm) {
  <form [formGroup]="directDepositForm" autocomplete="off">
    <div class="content-container form-comp mb-3">
      <div class="title" [ngClass]="lastUpdatedOn? 'd-flex justify-content-between' : ''">
        <mwp-text-translate text="{{title}}" jsonKey="directDepositFormTitle" />
      </div>
      <div class="row content mx-0">
        @if (errorMessage) {
          <div class="col-12 my-3">
            <div class="message-container red-fill">
              {{errorMessage}}
            </div>
          </div>
        }
        <div class="col-3 my-3">
          <mwp-dropdown [form]="directDepositForm" labelName="Payment Type" nameForControl="paymentOptionTypeId" [isListItemArray]="true" [data]="directDepositTypes" />
        </div>
        <div class="col-3 my-3">
          <mwp-input [form]="directDepositForm" labelName="Financial Institution" nameForControl="bankName"/>
        </div>
        <div class="col-3 my-3">
          <mwp-input [form]="directDepositForm" labelName="Routing Number" nameForControl="routingNumber" [maskType]="maskNumericType"/>
        </div>
        @if (!isEditing) {
          <div class="col-3 my-3">
            <mwp-input [form]="directDepositForm" labelName="Account Number" nameForControl="accountNumber" [maskType]="maskNumericType"/>
          </div>
        }
        @if (isEditing) {
          <div class="col-3 my-3">
            <mwp-input [form]="directDepositForm" labelName="Account Number" nameForControl="accountNumberForValidation" [maskType]="maskNumericType"/>
          </div>
        }
      </div>
    </div>
  </form>
}
@if (isEditing) {
  <div class="d-flex justify-content-end">
    <button class="mwp-button-secondary" (click)="cancel()">
      <mwp-text-translate text="Cancel" jsonKey="cancel" />
    </button>
    <button class="mwp-button-save ms-3" [disabled]="!directDepositForm.valid" (click)="save()">
      <mwp-text-translate text="Submit Direct Deposit" jsonKey="submitDirectDeposit" />
    </button>
  </div>
}